export default "__VITE_ASSET__C8U0W0vE__"